import { Table, Text } from '@mantine/core';

import { TRIGGERS_ANALYTICS_COLUMNS } from '../../../constants';
import { analyticsTypes } from '../../../types';

import { KeywordsList } from './KeywordsList';

type TriggersAnalyticsRowProps = {
  row: analyticsTypes.TriggersReportRow & analyticsTypes.TriggersRowInfo;
};

function isRecord(
  value: string | number | Record<string, number>
): value is Record<string, number> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export const TriggersAnalyticsRow = ({ row }: TriggersAnalyticsRowProps) => (
  <Table.Tr key={`row-${row.expertId}`}>
    {TRIGGERS_ANALYTICS_COLUMNS.map(({ key }) => {
      const cellValue = row[key];
      return (
        <Table.Td key={`cell-${key}`}>
          {isRecord(cellValue) ? <KeywordsList keywords={cellValue} /> : <Text>{cellValue}</Text>}
        </Table.Td>
      );
    })}
  </Table.Tr>
);
